import React from 'react'
import { Helmet } from 'react-helmet-async'

const NoIndexHelmet = ({ title }) => (
  <Helmet>
    {title && <title>{title}</title>}
    <meta name="robots" content="noindex,nofollow" />
    <meta name="googlebot" content="noindex,nofollow" />
  </Helmet>
)

export const NoIndexPage = ({ title, children }) => (
  <>
    <NoIndexHelmet title={title} />
    {children}
  </>
)

export default NoIndexHelmet
